export default __webpack_public_path__ + "static/media/boots_of_ferine_anger.48ae3622.jpg";